var config = require("./config/index");
var display = require("./config/display");
var pages = require("./config/pages");
var applist = require("./config/applist");
var routerUtils = require("../utiles/routerUtils");

var configs = Object.assign({}, config, display, pages, applist);

module.exports = {
  addRoute: function (router, $this) {
    routerUtils.isLogin(router, true);
    for (var key in configs) {
      var route = configs[key];
      // 用闭包处理回调函数只拿到最后的变量
      (function (arg) {
        router.addRoute(arg.url, function (req, next) {
          $this.clear();
          if (arg.initRoute) {
            arg.initRoute();
          }
          if (arg.callback) {
            arg.callback(req, next);
          }
          $this.reloadPage(arg.page);
        });
      })(route);
    }
  },
  config: configs,
};



//////////////////
// WEBPACK FOOTER
// ./src/routes/routeUtils.js
// module id = 211
// module chunks = 0